import { useMutation } from "@tanstack/react-query";

import { generateSoilSightOutcomes } from "services";

import { useIsAuthenticated } from "utils";

import { MUTATE_SOIL_SIGHT_OUTCOMES, TIMEOUT_LONG_RUNNING } from "consts";

interface UseMutateSoilSightOutcomesOptions {
  // When true, the global axios error toast is suppressed for this mutation so the caller can show
  // its own context-specific message (e.g. a single "Soil Sights temporarily unavailable" toast)
  // instead of stacking a second generic toast on top of it.
  hideErrorMessage?: boolean;
}

export const useMutateSoilSightOutcomes = ({ hideErrorMessage = false }: UseMutateSoilSightOutcomesOptions = {}) => {
  const isAuthenticated = useIsAuthenticated();

  return useMutation({
    mutationKey: [MUTATE_SOIL_SIGHT_OUTCOMES],
    mutationFn: (projectId: string) => {
      if (!isAuthenticated) {
        return Promise.reject(new Error("Not Authorized"));
      }
      // A synchronous project-wide calculation, so the 30s default is too short.
      return generateSoilSightOutcomes(projectId, { timeout: TIMEOUT_LONG_RUNNING, ...(hideErrorMessage ? { hideErrorMessage: true } : {}) });
    },
  });
};
